import { merge } from '@inpart-io/devtools';
import { getDataObjectsModule } from '@inpart-io/devtools-vue';
import { agreementDocumentsManager, type IAgreementDocument } from '@inpart-io/padme-iap';

import { store } from '@/store';
import { getBinaryUploadModule } from '@/store/base/binary-uploads/module';
import { getSearchModule } from '@/store/base/search/module';

const AGREEMENT_DOCUMENT_MODULE = 'agreementDocument';

const dataObjectModule = getDataObjectsModule<IAgreementDocument>(agreementDocumentsManager);
const searchModule = getSearchModule<IAgreementDocument>(agreementDocumentsManager);
const binaryUploadModule = getBinaryUploadModule<IAgreementDocument>(agreementDocumentsManager);

const agreementDocumentModuleInstance = merge<unknown>(dataObjectModule, searchModule, binaryUploadModule);
store.registerModule(AGREEMENT_DOCUMENT_MODULE, agreementDocumentModuleInstance);

export { AGREEMENT_DOCUMENT_MODULE };
